import { getAsRepairFieldDisplayValue } from './asRepairFormConfig';

export const AS_REPAIR_DEVICE_TYPE = {
    ADJUSTER: 'adjuster',
    CONTROLLER: 'controller',
};

/** 모델명 3- → 조절기, 2- → 제어기 */
export const getAsRepairDeviceTypeFromModelName = (modelName) => {
    const name = String(modelName || '').trim();
    if (name.startsWith('3-')) {
        return AS_REPAIR_DEVICE_TYPE.ADJUSTER;
    }
    if (name.startsWith('2-')) {
        return AS_REPAIR_DEVICE_TYPE.CONTROLLER;
    }
    return null;
};

export const getAsRepairModelNameFromRow = (row, listSummary, formConfig) => {
    const modelCol = listSummary?.columns?.find((c) => c.id === 'modelName');
    if (modelCol?.field) {
        const val = getAsRepairFieldDisplayValue(modelCol.field, row, formConfig);
        if (val != null && String(val).trim() !== '') {
            return String(val).trim();
        }
    }
    const fallback = row?.productName ?? row?.extra?.productName;
    return fallback != null ? String(fallback).trim() : '';
};

export const getAsRepairDeviceTypeFromRow = (row, listSummary, formConfig) => (
    getAsRepairDeviceTypeFromModelName(getAsRepairModelNameFromRow(row, listSummary, formConfig))
);

export const getAsRepairDeviceTypeLabel = (deviceType) => {
    if (deviceType === AS_REPAIR_DEVICE_TYPE.ADJUSTER) {
        return '조절기';
    }
    if (deviceType === AS_REPAIR_DEVICE_TYPE.CONTROLLER) {
        return '제어기';
    }
    return null;
};

export const rowMatchesAsRepairDeviceTypeFilters = (row, listSummary, formConfig, typeFilters) => {
    if (typeFilters?.adjuster && typeFilters?.controller) {
        return true;
    }
    const deviceType = getAsRepairDeviceTypeFromRow(row, listSummary, formConfig);
    if (!deviceType) {
        return false;
    }
    if (deviceType === AS_REPAIR_DEVICE_TYPE.ADJUSTER) {
        return !!typeFilters?.adjuster;
    }
    if (deviceType === AS_REPAIR_DEVICE_TYPE.CONTROLLER) {
        return !!typeFilters?.controller;
    }
    return false;
};

export const filterAsRepairRowsByDeviceType = (rows, listSummary, formConfig, typeFilters) => {
    const list = Array.isArray(rows) ? rows : [];
    return list.filter((row) => rowMatchesAsRepairDeviceTypeFilters(row, listSummary, formConfig, typeFilters));
};
